import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import CustomInput from "../Input";

import IconSearch from "images/icon-search.svg";

import "./style.scss";

const SearchInput = ({ onSearch, onChange, reset, setReset, resetData=()=>{} }) => {
  const [value, setValue] = useState("");

  useEffect(() => {
    onChange(value);
    resetData({reset:() => {
      setValue('')
    }})
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  useEffect(() => {
    if (reset) {
      setValue('')
      onSearch('')
      setReset(false)
    }
  }, [reset, setValue, onSearch, setReset])

  return (
    <div className="search-input">
      <CustomInput
        className="search-input-text"
        value={value}
        size="sm"
        onChange={setValue}
        onPressEnter={() => onSearch(value)}
      />
      <div className="search-input-icon" style={{cursor:'pointer'}} onClick={() => onSearch(value)}>
        <img src={IconSearch} alt="search-icon" />
      </div>
    </div>
  );
};

SearchInput.propTypes = {
  onChange: PropTypes.func,
  onSearch: PropTypes.func,
  setReset: PropTypes.func,
  reset: PropTypes.bool
};

SearchInput.defaultProps = {
  onChange: () => { },
  onSearch: () => { },
  reset: false,
  setReset: () => { },
};

export default SearchInput;
